import farfetch, { prefix } from "farfetch";

const criarComunicacaoHTTPComExcel = ({ url, key, idSessao }) => {
  const http = farfetch
    .set("x-functions-key", key)
    .use(prefix(url))
    .use(req =>
      req.method === "POST" ? req.set("Content-Type", "application/json") : req
    )
    .use(req =>
      req.headers["Content-Type"] === "application/json"
        ? { ...req, body: JSON.stringify(req.body) }
        : req
    );

  let filaDeEnvio = [];
  setInterval(() => {
    if (filaDeEnvio.length > 0) {
      http
        .post(`/${idSessao}`)
        .send(filaDeEnvio)
        .end();
      filaDeEnvio = [];
    }
  });

  const enviarMensagem = msg => {
    filaDeEnvio.push(msg);
  };
  const receberMensagens = () =>
    http.get(`/${idSessao}`).then(res => res.json());

  return {
    receberMensagens,
    enviarPing: () => enviarMensagem({ tipo: "PING" }),
    enviarPong: () => enviarMensagem({ tipo: "PONG" }),
    enviarMedidas: (ativo, medidas) =>
      enviarMensagem({ tipo: "MEDIDAS_SELECIONADAS", ativo, medidas }),
    enviarQTLink: (ativo, arquivo) =>
      enviarMensagem({ tipo: "QTLINK", ativo, arquivo }),
    desconectar: () => enviarMensagem({ tipo: "DESCONECTAR" }),
  };
};

export default criarComunicacaoHTTPComExcel;
